{
  "app": {
    "iframeTitle": "App window"
  },
  "associatedThreads": {
    "created": "Created {{when}}",
    "emptyText": "This lists the Nolë conversations that edited this node.",
    "emptyTitle": "No AI thread has modified this node yet.",
    "intro": "Nolë conversations that edited this node.",
    "loadError": "Error loading associated threads.",
    "noSummary": "No summary available.",
    "openInNole": "Open in Nolë",
    "openTooltip": "Open this thread in the Nolë panel"
  },
  "audio": {
    "noAudio": "No audio"
  },
  "cards": {
    "ascending": "Ascending",
    "descending": "Descending",
    "fieldsOnCards": "Fields on cards",
    "manualOrder": "Manual order",
    "new": "New",
    "sort": "Sort"
  },
  "custom": {
    "editLayout": "Edit layout",
    "hiddenFields_one": "{{count}} field not in the layout",
    "hiddenFields_other": "{{count}} fields not in the layout",
    "nodeGone": "This node no longer exists",
    "rowGone": "This row no longer exists",
    "unknownTemplate": "Unknown template"
  },
  "database": {
    "convertDescription": "The rows are copied into a simple table, in the database's order. Each row's history, its views and the deleted rows are lost. Rows shown on the canvas stay there as separate nodes. A table holds at most 1,000 rows.",
    "convertError": "Could not convert the database",
    "convertTitle": "Convert to a simple table?",
    "convertToTable": "Convert to a simple table",
    "converted": "The database is now a simple table.",
    "importStopped_one": "Import stopped: {{imported}} of {{count}} row was imported.",
    "importStopped_other": "Import stopped: {{imported}} of {{count}} rows were imported.",
    "settings": "Database settings",
    "trash": {
      "description": "Deleted rows are kept 30 days, then deleted for good.",
      "empty": "No deleted rows.",
      "restoreError": "Could not restore the row",
      "title": "Deleted rows"
    },
    "updateError": "Error updating the database"
  },
  "databaseTable": {
    "detach": "Detach",
    "detachDescription": "They leave the database and stay on the canvas as separate nodes.",
    "detachTitle_one": "Detach {{count}} row?",
    "detachTitle_other": "Detach {{count}} rows?",
    "limitHint_one": "At most {{count}} row at a time",
    "limitHint_other": "At most {{count}} rows at a time",
    "projectOnCanvas": "Project on canvas",
    "restoreError": "Could not restore the rows",
    "rowHidden": "This row is hidden by this view's filters, or was deleted.",
    "rowsMovedToTrash_one": "{{count}} row moved to this database's trash.",
    "rowsMovedToTrash_other": "{{count}} rows moved to this database's trash."
  },
  "databaseView": {
    "addError": "Could not add the view",
    "added": "{{view}} view added next to the database.",
    "databaseGone": "Its database is in the trash or on another canvas",
    "newView": "New view",
    "openDatabase": "Open {{title}}",
    "renameError": "Could not rename the view",
    "types": {
      "gallery": "Gallery",
      "kanban": "Board",
      "table": "Table",
      "timeline": "Timeline"
    },
    "untitled": "Untitled view",
    "updateError": "Could not update the view"
  },
  "dialogs": {
    "threads": "Threads that modified this node",
    "versionHistory": "Version history"
  },
  "errorBoundary": {
    "message": "Reloading the page usually fixes it — your work is saved on the server.",
    "title": "This window could not be opened"
  },
  "frame": {
    "empty": "This frame is empty",
    "emptyEditable": "This frame is empty — right-click to add a node",
    "exitFullscreen": "Exit fullscreen",
    "expand": "Expand",
    "expandFullscreen": "Expand to fullscreen",
    "maxMinimized_one": "Maximum {{count}} minimized window reached",
    "maxMinimized_other": "Maximum {{count}} minimized windows reached",
    "minimize": "Minimize",
    "moreOptions": "More options",
    "navigateToNode": "Navigate to node",
    "pin": "Pin to the right panel",
    "refresh": "Refresh window",
    "unpin": "Unpin: make it a floating window"
  },
  "image": {
    "addImage": "Add an image",
    "alt": "Selected"
  },
  "kanban": {
    "addStatus": "Add a Status field",
    "checked": "Checked",
    "firstOf": "First {{shown}} of {{count}}",
    "groupBy": "Group by {{field}}",
    "noValue": "No {{field}}",
    "pickerHint": "A board groups the rows by a select, status or checkbox field.",
    "showMore": "Show more ({{count}})",
    "statusFieldName": "Status",
    "unchecked": "Unchecked"
  },
  "link": {
    "noLink": "No link",
    "openInNewTab": "Open in a new tab"
  },
  "links": {
    "backlinks": {
      "empty": "No node mentions this one yet.",
      "hint": "Nodes that mention this one, via @mentions or table references.",
      "title": "Backlinks"
    },
    "connections": {
      "empty": "No connections yet.",
      "hint": "This node's connections (canvas edges) to other nodes.",
      "incoming": "Source — this block points to the current block",
      "outgoing": "Target — the current block points to this block",
      "title": "Connections"
    },
    "database": {
      "rowHint": "The database this row belongs to.",
      "title": "Database",
      "viewHint": "The database this view shows.",
      "views": "Views",
      "viewsHint": "The views of this database on the canvas."
    },
    "node": "Node",
    "threads": {
      "empty": "No Nolë conversation edited this node yet.",
      "hint": "Nolë conversations that created or edited this node.",
      "notOwner": "This thread belongs to another user",
      "openInPanel": "Open in the Nolë panel",
      "title": "Threads",
      "untitled": "Untitled thread"
    }
  },
  "loadingState": {
    "creating": "Creating",
    "loading": "Loading",
    "preparingDocument": "Preparing document"
  },
  "outline": {
    "empty": "Add headings to generate the outline.",
    "pdfEmpty": "No outline available.",
    "pdfNotIndexed": "This PDF's text isn't indexed yet, so it can't be searched.",
    "title": "Outline"
  },
  "pdf": {
    "nextPage": "Next page",
    "pageOf": "Page {{page}} of {{total}}",
    "previousPage": "Previous page",
    "resetZoom": "Reset zoom",
    "zoomIn": "Zoom in",
    "zoomOut": "Zoom out"
  },
  "file": {
    "noFile": "No file",
    "noPreview": "No preview for this kind of file: download it to open it.",
    "openInNewTab": "Open in a new tab",
    "previewFailed": "This file could not be previewed: download it to open it.",
    "emptySheet": "This sheet is empty.",
    "rowsCapped": "First {{shown}} rows of {{total}}: download the file to see them all.",
    "pagesNotIndexed": "The preview appears once the file is indexed. It can take a minute after the upload.",
    "slideNumber": "Slide {{n}}",
    "kinds": {
      "pdf": "PDF document",
      "image": "Image",
      "audio": "Audio",
      "video": "Video",
      "word": "Word document",
      "spreadsheet": "Spreadsheet",
      "presentation": "Presentation",
      "text": "Text file",
      "archive": "Archive",
      "other": "File"
    }
  },
  "row": {
    "delete": "Delete row",
    "detachError": "Could not detach the row",
    "detachFrom": "Detach from {{database}}",
    "detachManyError": "Could not detach the rows",
    "detached": "Detached from the database. It stays on the canvas.",
    "inTrash": "This row is in its database's trash.",
    "manyDetached_one": "{{count}} row detached from the database. It stays on the canvas.",
    "manyDetached_other": "{{count}} rows detached from the database. They stay on the canvas.",
    "manyShownOnCanvas_one": "{{count}} row displayed on the canvas. It stays in this database.",
    "manyShownOnCanvas_other": "{{count}} rows displayed on the canvas. They stay in this database.",
    "movedToTrash": "Row moved to this database's trash.",
    "projectOnCanvas": "Project as a node on the canvas",
    "showError": "Could not show the row on the canvas",
    "showIn": "Show in {{database}}",
    "showManyError": "Could not show the rows on the canvas",
    "shownOnCanvas": "Displayed on the canvas. It stays in this database.",
    "theDatabase": "the database"
  },
  "search": {
    "noResults": "No results",
    "nothingMatches": "Nothing matches “{{query}}”.",
    "resultsAtLeast_one": "{{count}}+ result",
    "resultsAtLeast_other": "{{count}}+ results",
    "results_one": "{{count}} result",
    "results_other": "{{count}} results"
  },
  "sectionLabel": {
    "about": "About {{name}}",
    "aboutThis": "About this section"
  },
  "sidePanel": {
    "clearSearch": "Clear search",
    "plan": {
      "nothingToShow": "Nothing to show for this node type."
    },
    "searchPlaceholder": "Search in this node",
    "tabs": {
      "links": "Links",
      "plan": "Plan",
      "versions": "Versions"
    },
    "title": "Panel",
    "toggle": "Toggle side panel"
  },
  "table": {
    "convert": "Convert",
    "convertDescription": "Each row becomes a record with its own history, that can be opened, linked and processed one by one. The columns become the database's fields.",
    "convertError": "Could not convert the table",
    "convertTitle": "Convert to a database?",
    "convertToDatabase": "Convert to a database",
    "converted": "The table is now a database.",
    "defaultColumnName": "Column {{n}}",
    "emptyCell": "{{column}} (empty)",
    "emptyRow": "Empty row",
    "exportCsv": "Export in CSV",
    "exportFileName": "table",
    "importCsv": "Import a CSV file",
    "rowHidden": "This row is hidden by the table's search or filters.",
    "rowsDeleted_one": "{{count}} row deleted.",
    "rowsDeleted_other": "{{count}} rows deleted.",
    "settings": "Table settings",
    "updateError": "Error updating the table",
    "visibleOfTotal_one": "{{visible}} of {{count}} row",
    "visibleOfTotal_other": "{{visible}} of {{count}} rows"
  },
  "tableMeta": {
    "columns_one": "{{count}} column",
    "columns_other": "{{count}} columns",
    "rows_one": "{{count}} row",
    "rows_other": "{{count}} rows"
  },
  "timeline": {
    "earlier": "Earlier",
    "emptyPeriod": "No dated row in this period.",
    "inRangeAtLeast_one": "{{count}}+ in range",
    "inRangeAtLeast_other": "{{count}}+ in range",
    "inRange_one": "{{count}} in range",
    "inRange_other": "{{count}} in range",
    "later": "Later",
    "noDateField": "A timeline places the rows by a date field. Add one, then pick it in this view's options.",
    "today": "Today",
    "undated": "No {{field}} ({{n}})",
    "undatedDrag": "No {{field}} ({{n}}) — drag one onto the timeline",
    "zoom": {
      "month": "Month",
      "quarter": "Quarter",
      "week": "Week"
    }
  },
  "transcript": {
    "askNole": {
      "label": "A name or a word misheard? Ask Nolë to fix it in the transcript.",
      "prompt": "In this transcript, replace "
    },
    "empty": {
      "audio": {
        "callToAction": "Transcribe this audio to read it here, jump to any passage, and find what was said from search and from Nolë.",
        "unavailable": "Transcription is not available for this audio."
      },
      "failed": "The transcription failed.",
      "keepsGoing": "You can close this window, the transcription keeps going.",
      "tooLarge": "This file is too large to be transcribed.",
      "tooLargeMax": "This file is too large to be transcribed (max {{max}} MB).",
      "transcribe": "Transcribe",
      "transcribing": "Transcribing…",
      "transcribingParts": "Transcribing… {{done}}/{{total}} parts",
      "video": {
        "callToAction": "Transcribe this video to read it here, jump to any passage, and find what was said from search and from Nolë.",
        "unavailable": "Transcription is not available for this video."
      }
    },
    "export": {
      "copied": "Transcript copied to clipboard",
      "copyError": "Couldn't copy the transcript",
      "copyMarkdown": "Copy as Markdown",
      "copyText": "Copy text",
      "downloadTxt": "Download (.txt)",
      "includeTimestamps": "Include timestamps",
      "subtitles": "Subtitles ({{ext}})",
      "text": "Text (.txt)",
      "tooltip": "Copy or download the transcript",
      "trigger": "Export"
    },
    "item": "Item {{number}}",
    "outline": {
      "chapters": "Chapters",
      "chaptersHint": "The recording split by topic. Click a chapter to play it.",
      "noChapters": "No chapters yet — they appear shortly after a transcription.",
      "noTranscriptAudio": "No transcript yet. Transcribe this audio to get an outline.",
      "overview": "Overview",
      "overviewHint": "An overview of the whole recording, generated from its transcript."
    },
    "panel": {
      "chaptersHint": "The recording split by topic. Open a chapter to read it; click a line to play from there.",
      "generatedHint": "Text generated from this node's content, used to power search.",
      "matches_one": "Transcript · {{count}} match",
      "matches_other": "Transcript · {{count}} matches",
      "noneYet": "No transcript available yet.",
      "playFrom": "Play from {{time}}",
      "showLess": "Show less",
      "showMore": "Show more",
      "transcript": "Transcript",
      "transcriptHint": "Click a line to play from there. Chapters appear shortly after a transcription."
    },
    "retranscribe": {
      "label": "Re-transcribe",
      "running": "Transcribing again — this transcript will be replaced when it's done.",
      "tooltip": "Transcribe this file again — the current transcript, and any fixes made to it, will be replaced"
    }
  },
  "versions": {
    "author": {
      "agentFor": "Nolë for {{name}}",
      "someone": "Someone",
      "system": "System",
      "unknown": "Unknown author",
      "you": "You"
    },
    "banner": {
      "changes": "Changes",
      "highlightChanges": "Highlight changes",
      "restore": "Restore",
      "restoreAppText": "This restores the code of this version. The data your app has saved is left untouched. The current code is kept as a version, so you can go back at any time.",
      "restoreText": "This replaces the current content with this version. The current content is kept as a version, so you can go back at any time.",
      "restoreTitle": "Restore this version",
      "restoring": "Restoring…",
      "version": "Version"
    },
    "day": {
      "dateTime": "{{day}} {{time}}",
      "formatOtherYear": "MMMM d, yyyy",
      "formatThisYear": "EEEE, MMMM d",
      "today": "Today",
      "yesterday": "Yesterday"
    },
    "diff": {
      "added": "Added",
      "changed": "Changed",
      "fields": "Fields: {{fields}}",
      "none": "No changes",
      "oldest": "Oldest version kept: nothing earlier to compare with",
      "removed": "Removed",
      "since": "Changes since {{title}}",
      "tableMetaChanged": "Columns or view settings changed in this version.",
      "unavailable": "Changes unavailable."
    },
    "history": {
      "loadError": "Error loading version history.",
      "noEarlier": "No earlier versions yet: they appear as this block is edited.",
      "notVersioned": "This block has no version history.",
      "showOlder": "Show older versions"
    },
    "kind": {
      "baseline": "Earlier version",
      "created": "Created",
      "restored": "Restored",
      "restoredFrom": "Restored from {{title}}"
    },
    "list": {
      "current": "Current version",
      "nameCurrent": "Name the current version",
      "nameError": "Error naming version",
      "namePlaceholder": "Version name (empty to remove)",
      "nameThis": "Name this version",
      "rename": "Rename version",
      "statsTooltip": "Blocks, rows or fields added, removed and changed",
      "upToDate": "Up to date"
    },
    "preview": {
      "empty": "Empty.",
      "emptyDocument": "Empty document.",
      "noCode": "No code in this version.",
      "noLongerAvailable": "This version is no longer available.",
      "restoreError": "Error restoring version",
      "restored": "Version restored.",
      "templateUnresolved": "Preview unavailable (template not resolved).",
      "unavailable": "Preview unavailable."
    },
    "viewer": {
      "pick": "Pick a version to see what it contained and what changed."
    }
  },
  "video": {
    "noVideo": "No video",
    "noVideoYet": "No video yet."
  },
  "viewHeader": {
    "partial": "Only the first rows of the database were read: there may be more.",
    "rowHeight": "Row height",
    "searchPlaceholder": "Search…"
  },
  "viewSettings": {
    "addEndDates": "Add end dates to {{field}}",
    "cover": "Cover",
    "endDate": "End date",
    "endOf": "End of {{field}}",
    "groupBy": "Group by",
    "layout": "Layout",
    "startDate": "Start date",
    "title": "View settings"
  }
}
